/* RESPONSIBLE TEAM: team-automation-foundations */
import type { InterfaceIconName } from '@intercom/pulse/lib/interface-icons';

export const AgentType = {
  FIN: 'fin',
  FIN_SDR: 'fin_sdr',
  FIN_ECOMMERCE: 'fin_ecommerce',
  FIN_SUCCESS: 'fin_success',
  FIN_PROACTIVE: 'fin_proactive',
} as const;

export type AgentTypeValue = (typeof AgentType)[keyof typeof AgentType];

interface AgentTypeConfigEntry {
  icon: InterfaceIconName;
  containerClasses: string;
}

export const AGENT_TYPE_CONFIG: Record<AgentTypeValue, AgentTypeConfigEntry> = {
  [AgentType.FIN]: {
    icon: 'service-agent',
    containerClasses: 'bg-service-agent-fill text-on-service-agent',
  },
  [AgentType.FIN_SDR]: {
    icon: 'sales-agent',
    containerClasses: 'bg-sales-agent-fill text-on-sales-agent',
  },
  [AgentType.FIN_ECOMMERCE]: {
    icon: 'ecommerce-agent',
    containerClasses: 'bg-ecommerce-agent-fill text-on-ecommerce-agent',
  },
  [AgentType.FIN_SUCCESS]: {
    icon: 'success-agent',
    containerClasses: 'bg-success-agent-fill text-on-success-agent',
  },
  [AgentType.FIN_PROACTIVE]: {
    icon: 'send',
    containerClasses: 'bg-vis-cyan-40 text-on-neutral',
  },
};

export const DEFAULT_AGENT_TYPE = AgentType.FIN;
